import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {ValidationConstraint} from '../../domain/validation-constraint';
import {UtilService} from '../../services/util.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-custom-input-currency',
    templateUrl: './custom-input-currency.component.html',
    styleUrls: ['./custom-input-currency.component.scss']
})
export class CustomInputCurrencyComponent implements OnInit, OnChanges {
    @Input() inputId: string;
    @Input() focus: boolean;
    @Input() disabled: boolean;
    @Input() result: any;
    @Input() styleClass: string;
    @Input() labelClass: string;
    @Input() placeholder: string;
    @Input() required: boolean;
    @Input() tabIndex: string;
    @Input() errors: object;
    @Input() modelPath: string;
    @Input() label: string;
    @Input() numberFormat: string;
    @Input() max: number;
    @Input() min: number;
    @Input() allowDecimal: boolean;
    @Input() unit: string;
    @Input() name: string;
    @Input() validationConstraints: ValidationConstraint[];

    @Output() resultChange = new EventEmitter();
    @Output() enterKeyUp = new EventEmitter();
    @Output() blur = new EventEmitter();
    @ViewChild('control', {static: true}) input: ElementRef;
    @ViewChild('frm', {static: true}) form: any;

    public error: string;

    public fieldValidationConstraints: ValidationConstraint[];

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.focus) {
            setTimeout(() => this.input.nativeElement.focus(), 2000);
        }
        this.error = UtilService.getObjByPath(this.errors, this.modelPath);
        if (this.allowDecimal === undefined) {
            this.allowDecimal = true;
        }
        this.updataValidationConstraints();
        this.name = this.name || 'control';
    }

    onModelChanged($event) {
        this.resultChange.emit($event);
        this.cd.markForCheck();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.errors !== undefined) {
            this.error = UtilService.getObjByPath(this.errors, this.modelPath);
            if (this.form.form.controls[this.name] && this.error) {
                this.form.form.controls[this.name].markAsTouched(true);
                this.form.form.controls[this.name].setErrors({backend: {someProp: 'some message'}});
            }
        }
        if (!this.error && this.form.form.controls[this.name]) {
            this.form.form.controls[this.name].markAsUntouched(true);
        }

        if (changes.validationConstraints) {
            this.updataValidationConstraints();
        }
    }

    onEnter() {
        this.enterKeyUp.emit();
    }

    onBlur($event: FocusEvent) {
        this.blur.emit();
    }

    onPaste($event: ClipboardEvent) {
    }

    private updataValidationConstraints() {
        if (this.validationConstraints !== null && this.modelPath) {
            this.fieldValidationConstraints = _.filter(this.validationConstraints, ['field', this.modelPath]);
            this.cd.markForCheck();
        }
    }

}
